import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Supplier } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '../../../helper'

const log = new Logger('SupplierService')

/**
 * Đây là services dành cho Supplier
 */

@Injectable({ providedIn: 'root' })
export class SupplierService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng cho User
   */
  private _apiPath = {
    list: 'supplier/supplier_entity',
    detail: 'supplier/supplier_entity',
  }

  /**
   * Lấy tất cả Supplier đang available
   * @param params Danh sách tham số muốn truyền.
   * ex: { 'pagesize': 10, 'page':1 }
   */
  getAll(params?: any): Observable<any> {
    // let pa = new HttpParams();
    let pa = new HttpParams().set(
      'parameters[supplier_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Lấy thông tin chi tiết của Supplier dưạ vào @id
   * @param Id ID của Supplier
   */
  getDetail(id: string): Observable<Supplier> {
    return this.apiService.get<Supplier>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Tạo Supplier
   * @param res Thông tin Supplier
   */
  create(res: Supplier): Observable<any> {
    res.sid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Chỉnh sửa thông tin Supplier
   *
   * @param res Thông tin Supplier muốn chỉnh sửa
   */
  edit(res: Supplier): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.sid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Xóa thông tin Supplier
   *
   * @param id Xóa Supplier bằng Supplier ID
   */
  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        return data
      })
    )
  }
}
